var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analytics"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624139",
    x: 5,
    y: 10,
    width: 3,
    height: 10,
    rx: 1,
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624140",
    x: 11,
    y: 10,
    width: 3,
    height: 10,
    rx: 1,
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624141",
    x: 17,
    y: 5,
    width: 3,
    height: 15,
    rx: 1,
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 101",
    d: "M5.49998 7.5H12.1337C12.3702 7.5 12.5991 7.41617 12.7796 7.26339L19 2",
    stroke: "#1B90FE",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 551",
    cx: 6.5,
    cy: 7.5,
    r: 1.5,
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 554",
    cx: 12.5,
    cy: 7.5,
    r: 1.5,
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 555",
    cx: 18.5,
    cy: 2.5,
    r: 1.5,
    fill: "#1B90FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 102",
    d: "M2 2V22H23",
    stroke: "#1B90FE",
    strokeWidth: 1.4
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.7f0bd392adc9ebf00a9503fb43b81e1c.svg";
export { ForwardRef as ReactComponent };